(function () {
  const covers = document.querySelectorAll(".ci-Cover, .elementor-widget-depicter_slider");

  // Création d'une fonction pour mettre à jour la hauteur.
  const updateHeight = () => {
    covers.forEach((cover) => {
      const nextElement = cover.nextElementSibling;
      if (nextElement && nextElement.clientHeight < 300) {
        cover.style.setProperty("--next-element-height", `${nextElement.clientHeight}px`);
      }
    });
  };

  // Appel de la fonction pour initialiser la hauteur.
  updateHeight();

  // Écoute de l'événement 'resize' et mise à jour de la hauteur lorsque l'événement est déclenché.
  window.addEventListener("resize", updateHeight);
})();
